import { SiriusServiceBase, SiriusDataService } from '@ibtech/sirius-angular-service';
import { Injectable } from '@angular/core';
import { SalesTransactionInformationModel } from '../shared/models/salesinformation.model';
import { MemberInfo, CalculatedCommissionModel } from '../shared/models/shared.model';


@Injectable()
export class IndividualSalesService extends SiriusServiceBase {

    public dataServiceInstance: SiriusDataService;
    //service için kullanılacak parametreler buarada tanımlanabilir

    constructor() {
        super();
    }

    public createStpSellerTransaction(info: SalesTransactionInformationModel) {
        var promise = this.dataServiceInstance.post<SalesTransactionInformationModel>("CreateStpSellerTransaction", info);
        return promise;
    }

    public getStpCommission(amount: number) {
        let calculatedCommissionModel: CalculatedCommissionModel = new CalculatedCommissionModel();
        calculatedCommissionModel.SalesAmount = amount; 
        let promise = this.dataServiceInstance.post<CalculatedCommissionModel>("GetStpCommission", calculatedCommissionModel);
        return promise;
    }

    public updateCustomerInfo(memberInfo: MemberInfo) {
        let promise = this.dataServiceInstance.post<MemberInfo>("UpdateMemberInfo", memberInfo);
        return promise;
    }

    public getCustomerInfo() {
        let promise = this.dataServiceInstance.get("GetMemberInfo");
        return promise;
    }
}
